import { useState } from "react";
import axios from "axios";
import { formatApiErrorDetail } from "@/context/AuthContext";
import { Panel } from "@/components/admin/ui";
import { BusinessHoursEditor } from "@/components/org/settings/BusinessHoursEditor";
import { normalizeStructuredHours } from "@/lib/businessHours";

export const OfficeBusinessHoursTab = ({ meta, API, onSaved }) => {
  const [hours, setHours] = useState(normalizeStructuredHours(meta.business_hours));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const dirty = JSON.stringify(hours) !== JSON.stringify(normalizeStructuredHours(meta.business_hours));

  const save = async () => {
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      await axios.patch(`${API}/org/office/business-hours`, hours, { withCredentials: true });
      setSuccess("Business hours saved.");
      onSaved?.();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Panel
      title="Business Hours"
      subtitle="The organization-wide hours every Team and individual inherits from, unless overridden. This is the same data shown read-only in Organization Settings."
      testId="office-business-hours-tab"
      action={
        <button
          type="button"
          onClick={save}
          disabled={!dirty || saving}
          data-testid="office-business-hours-save-btn"
          className="rounded-xl border border-transparent bg-[#0052FF] px-3.5 py-2 text-xs font-bold text-white transition-colors duration-150 hover:bg-[#0040CC] disabled:cursor-not-allowed disabled:opacity-50"
        >
          {saving ? "Saving…" : "Save"}
        </button>
      }
    >
      {error && <p className="mb-3 text-sm font-semibold text-red-600 dark:text-red-400" data-testid="office-business-hours-error">{error}</p>}
      {success && <p className="mb-3 text-sm font-semibold text-emerald-600 dark:text-emerald-400" data-testid="office-business-hours-success">{success}</p>}
      <BusinessHoursEditor hours={hours} onChange={setHours} />
    </Panel>
  );
};
